import React from 'react';
import { styled } from '@compiled/react';
import EditorPanelIcon from '@atlaskit/icon/core/status-information';
import { token } from '@atlaskit/tokens';
import { useIntl } from '@atlassian/jira-intl';
import { MAX_COLUMNS } from '@atlassian/jira-native-issue-table/src/common/constants.tsx';
import { FireUiAnalytics } from '@atlassian/jira-product-analytics-bridge';
import messages from './messages.tsx';

export const ColumnPickerMaxSelectedColumns = () => {
	const { formatMessage } = useIntl();

	return (
		<>
			<MessageContainer>
				<EditorPanelIcon spacing="spacious" label="" />
				<Message>{formatMessage(messages.maxSelectedColumns, { maxColumns: MAX_COLUMNS })}</Message>
			</MessageContainer>
			<FireUiAnalytics
				actionSubject="maxSelectedFieldsMessage"
				action="viewed"
				actionSubjectId="columnPicker"
			/>
		</>
	);
};

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const MessageContainer = styled.div({
	display: 'flex',

	backgroundColor: token('color.background.neutral'),
	paddingTop: token('space.100'),
	paddingRight: token('space.100'),
	paddingBottom: token('space.100'),
	paddingLeft: token('space.100'),

	color: token('color.text.subtle'),
	marginTop: token('space.100'),
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const Message = styled.p({
	marginTop: 0,
	marginRight: 0,
	marginBottom: 0,
	marginLeft: token('space.100'),
	font: token('font.body.small'),
});
